const ColorSwatchSelected = props => {
  const { colors = [], general = {}, cx = "", mobile = false } = props || {}

  return (
    <p className={`color-swatch display-none${mobile ? "__desktop" : ""}`}>
      {colors?.map((color, i) => (
        <label
          htmlFor={`${color.name}-id`}
          key={`color-${color.sku}-${color.customerFacingSKU}-${i}`}
          role="radio"
          tabIndex="0"
          aria-label={`${color.name} color`}
          aria-checked={true}
          rel="noreferrer"
          title={color.name}
          className={cx({
            "selected-swatch": true,
          })}
        >
          <input
            type="radio"
            id={`${color.name}-id`}
            aria-label={`${color.name}`}
          />
          <img
            className="swatch-outline"
            role="presentation"
            src={`${general.swatchUrl}${color.swatch}${
              window.innerWidth <= 768
                ? "?$PLPSwatch_Mobile50$"
                : "?$PLPSwatch_Desk100$"
            }`}
            width="20px"
            alt={color.name}
          />
          <span className="color-text">{color.name}</span>
        </label>
      ))}
    </p>
  )
}
export default ColorSwatchSelected
